/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_Confirm_TitleInputs */

const vi_einvoice_publish_confirm_title = /** @type {(inputs: Einvoice_Publish_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận phát hành hóa đơn`)
};

/**

* @param {Einvoice_Publish_Confirm_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_confirm_title = /** @type {((inputs?: Einvoice_Publish_Confirm_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_Confirm_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_confirm_title(inputs)
});